// removed by extract-text-webpack-plugin
module.exports = {"newOverview":"newOverview--2YKJK","teaserWrapper":"teaserWrapper--RBVqe","date":"date--R9N4u","moreLink":"moreLink--1QP9C","hompageNews":"hompageNews--2ZaNb","secondColumn":"secondColumn--Bpati"};


//////////////////
// WEBPACK FOOTER
// ./components/NewsTeaser/styles.css
// module id = 1001
// module chunks = 2